import styled from 'styled-components';
import colors from '../../../../../styles/colors';

const Overlay = styled.div`
  position: absolute;
  inset: 0;
  background-color: ${colors.addAlpha(colors.base.beta, 0.3)};
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  z-index: 50;
`;

const Container = styled.div`
  background-color: ${colors.base.alpha};
  padding: 20px;
  border-radius: 4px;
  box-shadow: 0 0 10px 0 ${colors.addAlpha(colors.base.beta, 0.1)};
  min-width: 600px;
  max-width: 70vw;
  max-height: 60vh;
  overflow-y: auto;
`;

const MetaTable = styled.table`
  width: 100%;
  border-collapse: collapse;
  

  th {
   text-align: left;
   padding: 6px 0px;
   font-family: monospace;
   font-weight: bold;
   vertical-align: middle;
  }

  td {
    text-align: left;
    font-family: monospace;
  }
`;

const RecipeGrid = styled.div`
  display: grid;
  grid-template-columns: max-content 1fr;
  gap: 5px 12px;
  align-items: center;
`;

export {
  Container, Overlay, MetaTable, RecipeGrid,
};
